/**
 * @generated SignedSource<<76fe0c26858250eab4315ad55ae8233b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthReason = "BAD_LEVEL" | "CREDENTIALS_REFUSED" | "INVALID_EMAIL" | "LINK_REFUSED" | "NAME_REQUIRED" | "NAME_TOO_LONG" | "NATIVE_LANGUAGE_IS_ENGLISH" | "PASSWORD_REFUSED" | "RESET_REQUESTED" | "SIGNUP_ACCEPTED" | "WEAK_PASSWORD" | "%future added value";
export type AccountSettingsChangePasswordMutation$variables = {
  current: string;
  next: string;
};
export type AccountSettingsChangePasswordMutation$data = {
  readonly changePassword: {
    readonly ok: boolean;
    readonly reason: AuthReason | null | undefined;
  };
};
export type AccountSettingsChangePasswordMutation = {
  response: AccountSettingsChangePasswordMutation$data;
  variables: AccountSettingsChangePasswordMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "current"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "next"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "current",
        "variableName": "current"
      },
      {
        "kind": "Variable",
        "name": "new",
        "variableName": "next"
      }
    ],
    "concreteType": "ChangePasswordPayload",
    "kind": "LinkedField",
    "name": "changePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSettingsChangePasswordMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountSettingsChangePasswordMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "772803c96362621cd06efcfe76db29c3",
    "id": null,
    "metadata": {},
    "name": "AccountSettingsChangePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation AccountSettingsChangePasswordMutation(\n  $current: String!\n  $next: String!\n) {\n  changePassword(current: $current, new: $next) {\n    ok\n    reason\n  }\n}\n"
  }
};
})();

(node as any).hash = "22b3a04ea7642c9115b305bd3c737bd1";

export default node;
